import Search from './list';
import Tree from './tree';
import CodeStore from './batch';
import MapStore from './list/MapStore';
import BatchPrint from './batchPrint';
import Card from './card';
import Amkjzg from '../stores/amkjzg';
import Reply from './reply';
import BatchImportStore from "./list/BatchImportStore";
import LogListStore from "./list/LogListStore";
import customPageStore from "./custompage";
import ViewResouceStore from "./list/ViewResourceStore";
import TabStore from "./modetab/TabStore"
import TemplateManageStore from './list/TemplateManageStore';
import BatchAddStore from './list/BatchAddStore';
import cubeMind from './cubeMind';
import BoardStore from './board/BoardStore';
import MindMapStore from './mindMap/mindMapStore';
import DevStores from './dev';   
import TimelineStore from './timeline/TimelineStore';
import GanttStore from './gantt/GanttStore';

export default {
    Search,
    Tree,
    Amkjzg,
    Card: new Card(),
    QrCodeStore: new CodeStore(),
    BarCodeStore: new CodeStore(),
    mapStore: new MapStore(),
    reply: new Reply(),
    batchImport: new BatchImportStore(),
    cubeLogList: LogListStore,
    customPageStore,
    cubeViewResource: new ViewResouceStore(),
    TabStore:new TabStore(),
    templateManageStore:new TemplateManageStore(),
    batchAddStore:new BatchAddStore(),
    cubeMind:new cubeMind(),
    boardStore:new BoardStore(),
    mindMapStore:new MindMapStore(),
    BatchPrint:new BatchPrint(),
    timelineStore:new TimelineStore(),
    ganttStore:new GanttStore(),
    ...DevStores
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/index.ts